import { render, staticRenderFns } from "./Boss.vue?vue&type=template&id=6dbf16df&"
import script from "./Boss.vue?vue&type=script&lang=js&"
export * from "./Boss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports